// extracted by mini-css-extract-plugin
module.exports = {"notFound":"style_notFound__2vgLI"};